import { createSafeContext } from '@mews/framework';
import { FilterFormValues } from './schemas';

export const { FilterValuesContextProvider, useFilterValuesContext } = createSafeContext<
    'FilterValuesContext',
    FilterFormValues
>('FilterValuesContext');
